export const TABLE_THEME = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
} as const;

export type TableTheme = (typeof TABLE_THEME)[keyof typeof TABLE_THEME];
